// extracted by mini-css-extract-plugin
module.exports = {"menu-item-selected":"ChainDropdownItem_menu-item-selected__Vgi3c","icon-button":"ChainDropdownItem_icon-button__20H7L","container":"ChainDropdownItem_container__21p9n"};